module.exports = __webpack_public_path__ + "static/media/color.54337c94.svg";